import React from 'react';

const PreSeedSVG = () => {
  return (
    <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 8C6.20914 8 8 6.20914 8 4C8 1.85792 6.31621 0.109104 4.19997 0.00491165C4.08965 -0.000520101 4 0.0895431 4 0.2V3.8C4 3.91046 3.91046 4 3.8 4H0.2C0.0895431 4 -0.000520106 4.08965 0.00491164 4.19997C0.109104 6.31621 1.85792 8 4 8Z"
        fill="#FAC800"
      />
    </svg>
  );
};

export default PreSeedSVG;
